export const BROWSER_CHECK_PASSED = 'BROWSER_CHECK_PASSED';

export const browserCheckPassed = () => ({
  type: BROWSER_CHECK_PASSED,
});
